import {
  ImageCaptureMode,
  InspectionType,
  ScoreWeightModes,
  ScoringModels,
} from '@main-application/inspections/models/rest-inspections-model.interface';
import { MobileUIMode } from '@main-application/shared/template-editor-dialog/components/template-editor-dialog/mobile-ui-menu/mobile-ui-menu.component';
import { RestUserModel } from '@shared/interfaces/user.interface';

export interface RestTemplateModel {
  id: number;
  name: string;
  customInspectionIsRequired: boolean;
  propertyId: number;
  unitType: string;
  inspectionType: InspectionType;
  inspectionTemplateAreas: RestTemplateAreaModel[];
  editable: boolean;
  turboMode?: boolean;
  isAvailable: boolean;
  isDeleted: boolean;
  isScheduledForDeletion: boolean;
  additionalBathroomInspectionTemplateAreaIds?: number[];
  additionalBedroomInspectionTemplateAreaIds?: number[];
  additionalHalfBathRoomInspectionTemplateAreaIds?: number[];
  additionalAnyBathRoomInspectionTemplateAreaIds?: number[];
  postCompleteSurveyInspectionTemplateAreaIds?: number[];

  createdAt: string;
  createdBy: number;
  createdByUser: RestUserModel;
  modifiedAt: string;
  modifiedBy: number;
  modifiedByUser: RestUserModel;
  description: string;
  isGlobalTemplate: boolean;
  parentInspectionId?: number;
  dynamicInspectionId?: number;

  scoringModel?: ScoringModels;
  resultScore?: number;
  scoreWeightMode?: ScoreWeightModes;
  scoreWeight?: number;
  itemsScore?: number;
  nspireUnitDecisionAreaId: number;
  isNSPIRECompatible?: boolean;
  residentSignatureRequired: boolean;
  hidePropertyManagerSignature: boolean;
  showDefaultAnswersInTheReport: boolean;
  showInstructions: boolean;
  instructionsText: string;
  inspectionTemplateCategoryId: number;
  excludeFromFilters: boolean;
  inspectionTemplateKind: TemplateType;
  standardTemplateImagePickerMode: ImageCaptureMode;
  mobileUIMode?: MobileUIMode;
}

export enum TemplateType {
  Standard,
  LeaseAudit,
  NSpire,
}

export interface RestTemplateAreaModel {
  id: number;
  title: string;
  areaSurveyJson: string;
  inspectionTemplateId: number;
  position: number;
  steps: number;

  scoringModel?: ScoringModels;
  resultScore?: number;
  scoreWeightMode?: ScoreWeightModes;
  scoreWeight?: number;
  itemsScore?: number;
}

export interface RestInspectionTemplateCategoryModel {
  createdBy: Pick<
    RestUserModel,
    | 'id'
    | 'dateCreated'
    | 'azureId'
    | 'userGroupType'
    | 'isActive'
    | 'email'
    | 'displayName'
    | 'emailAddedAsIdentity'
    | 'firstName'
    | 'lastName'
    | 'nativeLanguage'
    | 'phoneNumberAddedAsIdentity'
  >;
  dateCreated: Date;
  id: number;
  name: string;
}
